export default "__VITE_ASSET__DsUM3PAF__"